'use client'

import React, { useState } from 'react'
import type { Tweet } from 'react-tweet/api'
import { EmbeddedTweet, TweetSkeleton, useTweet } from 'react-tweet'
import { normalizeSyndicationTweetEntities } from '@/lib/normalizeSyndicationTweetEntities'
import styles from './XFeed.module.scss'
import fallbackTweetIds from './xFeedData.json' // simple array of the 2 latest tweetIds
import { useXFeeds } from '@/src/app/hooks/useXFeeds'

const TweetCard: React.FC<{ postId: string }> = ({ postId }) => {
  const apiUrl = `/api/tweet/${postId}`
  const { data, error, isLoading } = useTweet(postId, apiUrl)

  if (isLoading) {
    return (
      <div className={styles.tweetCard}>
        <TweetSkeleton />
      </div>
    )
  }

  if (error || !data) {
    return null
  }

  const tweet = normalizeSyndicationTweetEntities(
    data as unknown as Record<string, unknown>,
  ) as unknown as Tweet

  return (
    <div className={styles.tweetCard}>
      <EmbeddedTweet tweet={tweet} />
    </div>
  )
}

const XFeed: React.FC = () => {
  const [theme] = useState('dark')
  let posts = []

  const { data: tweets } = useXFeeds()

  if (tweets?.length > 0) {
    posts = tweets.slice(0, 2).map((tweet) => tweet.id)
  } else {
    posts = fallbackTweetIds
  }

  return (
    <div className={styles.section}>
      <div className={styles.container}>
        {/* pink border */}
        <div className={styles.decorativeLabel}>
          <span aria-disabled>06</span>&nbsp;X feed
        </div>

        {/* Main Content Panel */}
        <div className={styles.feedPanelWrapper}>
          <div className={styles.feedPanel} data-theme={theme}>
            <h3 className={`${styles.panelTitle} font-gt-haptik`}>Posts from @Threatlabz</h3>
            {posts.map((postId) => (
              <TweetCard key={postId} postId={postId} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default XFeed
